import { SelectionState } from '@alfresco/adf-extensions';
import { Action } from '@ngrx/store';

//Enum de acciones disponibles
export enum AldenActionTypes {
  ReloadCustomListTable = 'RELOAD_CUSTOM_LIST_TABLE',
  ReloadDataListElements = 'RELOAD_DATALIST_ELEMENTS',
  ShowHideFiltersHeaderTable = 'SHOW_HIDE_FILTERS_HEADER_TABLE',
  ViewAbout = 'VIEW_ABOUT',
  DeleteElements = 'DELETE_ELEMENTS',
  UploadFileVersion = 'ALDEN_UPLOAD_FILE_VERSION',
  DocumentLocation = 'ALDEN_DOCUMENT_LOCATION',
  SaveSearchHeader = 'SAVE_SEARCH',
  SaveViewerConfig = 'SAVE_VIEWER_CONFIG',
  DownloadWithWatermark = 'DOWNLOAD_WITH_WATERMARK'
}

/*
 * Acción para reiniciar la tabla de CustomList
 */
export class ReloadCustomListTableAction implements Action {
  readonly type = AldenActionTypes.ReloadCustomListTable;

  /**
   * Constructor de la clase `ReloadCustomListTableAction`.
   * @param {boolean} resetFilters - Indica si se deben restablecer los filtros.
   * @param {number} delaySeconds - Tiempo de retraso en segundos (opcional, por defecto 0).
   */
  constructor(public resetFilters: boolean, public delaySeconds: number = 0,  public clearState?: boolean) {}
}

/*
 * Acción para reiniciar la tabla de CustomList
 */
export class ReloadDataListElementsAction implements Action {
  readonly type = AldenActionTypes.ReloadDataListElements;

  /**
   * Constructor de la clase `ReloadDataListElementsAction`.
   * @param {boolean} reset - Permite invalidar la caché de las peticiones existentes para forzar la recarga de los Data Lists..
   * @param {boolean} resetOnlyDynamic - Está activo junto con reset, únicamente se invalidan las entradas de caché correspondientes a columnas cuyo atributo dynamic sea true.
   */
  constructor(public reset: boolean, public resetOnlyDynamic?: boolean) {}
}

/*
* Acción que indica que se deben mostrar u ocultar los filtros de la cabecera de la tabla.
*/
export class ShowHideFiltersHeaderTableAction implements Action {
  readonly type = AldenActionTypes.ShowHideFiltersHeaderTable;

  /**
   * Constructor de la clase `ShowHideFiltersHeaderTableAction`.
   * No acepta ningún parámetro.
   */
  constructor() {}
}

/*
 * Acción para abrir el dialogo de About
 */
export class ViewAboutAction implements Action {
  readonly type = AldenActionTypes.ViewAbout;

  /**
   * Constructor de la clase `ViewAboutAction`.
   * No acepta ningún parámetro.
   */
  constructor() {}
}

/*
 * Acción para eliminar un nodo seleccionado mediante la capa de servicio
 */
export class DeleteElementsAction implements Action {
  readonly type = AldenActionTypes.DeleteElements;

  /**
   * Constructor de la clase `DeleteElementsAction`.
   * @param {SelectionState} selection - Estado opcional de la selección.
   */
  constructor(public selection?: SelectionState) {}
}

/*
 * Acción para cargar una nueva versión de un documento
 */
export class UploadFileVersionAction implements Action {
  readonly type = AldenActionTypes.UploadFileVersion;

  /**
   * Constructor de la clase `UploadFileVersionAction`.
   * @param {SelectionState} selection - Estado opcional de la selección.
   */
  constructor(public selection?: SelectionState) {}
}

/*
 * Acción para ir a la ubicación de un fichero desde un visor nuestro
 */
export class DocumentLocationAction implements Action {
  readonly type = AldenActionTypes.DocumentLocation;

  /**
   * Constructor de la clase `DocumentLocationAction`.
   * @param {SelectionState} selection - Estado opcional de la selección.
   */
  constructor(public selection?: SelectionState) {}
}

/*
* Acción que permite guardar la búsqueda actual en la carpeta personal del usuario.
*/
export class SaveSearchHeaderAction implements Action {
  readonly type = AldenActionTypes.SaveSearchHeader;

  /**
   * Constructor de la clase `ShowHideFiltersHeaderTableAction`.
   * No acepta ningún parámetro.
   */
  constructor() {}
}

/*
* Acción que permite guardar la configuración del visor actual en la carpeta personal del usuario.
*/
export class SaveViewerConfigHeaderAction implements Action {
  readonly type = AldenActionTypes.SaveViewerConfig;

  /**
   * Constructor de la clase `SaveViewerConfigHeaderAction`.
   * No acepta ningún parámetro.
   */
  constructor() {}
}

export class DownloadWithWatermarkAction implements Action {
  readonly type = AldenActionTypes.DownloadWithWatermark;
  /**
   * Constructor de la clase `DownloadWithWatermarkActiom`.
   *  @param {SelectionState} selection - Estado opcional de la selección.
   */
  constructor(public selection?: SelectionState) {}
}